import { Pipe, PipeTransform } from '@angular/core';
import { ContractTypeValue } from '../../interfaces/contract';

@Pipe({
  name: 'contractTypeValue'
})
export class ContractTypeValuePipe implements PipeTransform {

  transform(value: ContractTypeValue): string {
    const type = {
      [ContractTypeValue.MONETARY]: 'Monetário',
      [ContractTypeValue.PERCENTAGE]: 'Percentual'
    }

    return type[value]
  }

}
